import { computed } from 'vue'

import { useHomepageStore } from '@/stores/homepageComponents'

export const fetchPlatformsStore = async () => {
  const homepageStore = useHomepageStore()
  await homepageStore.fetchAllHomepageComponents()
}

export const usePlatformsData = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.platforms_section || {})
}
